import {persistState, PersistStateSelectFn, Query, selectPersistStateInit, Store, StoreConfig} from "@datorama/akita"
import produce from "immer"
import Logger from "logger/logger"
import {envCreateInitState, IEnvStore} from "store/system/environment/env.model"
import {supportedLanguages} from "utils/langMapper"
import {onEmit} from "utils/onEmit"

@StoreConfig({name: 'env', resettable: true, producerFn: produce})
export class EnvStore extends Store<IEnvStore> {
  constructor() {
    super(envCreateInitState())

    // On init, reset the language if it's not supported. This should trigger browser detection
    onEmit(selectPersistStateInit(), () => {
      const lng = this.getValue().language
      if (lng && supportedLanguages().indexOf(lng) < 0) {
        Logger('warn.ENV.fixing langauge', lng)
        this.update(state => {
          state.language = undefined
        })
      }
    })


  }
}

export const envStore = new EnvStore()

class EnvQuery extends Query<IEnvStore> {
  constructor(protected store: EnvStore) {
    super(store)
  }
}

export const envQuery = new EnvQuery(envStore)

// Create persistent storage
const envSelectToken: PersistStateSelectFn<IEnvStore> = state => ({
  themeMode: state.themeMode,
  language: state.language
})
envSelectToken.storeName = 'env'

export const rootEnvPersistedStorage = persistState({
  key: 'sticky.env',
  include: ['env'],
  select: [envSelectToken],
})
